"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productStock = void 0;
exports.productStock = function (axios) {
    return {
        /** @deprecated getOptionsStocksV2 사용해주세요 */
        getOptionsStocks: function (request) {
            return axios.get('/options/stocks', request);
        },
        getOptionsStocksV2: function (request) {
            return axios.get('/options/stocks', request);
        },
        getOptionsStocksExcel: function (request) {
            return axios.get('/options/stocks/excel', request);
        }
    };
};
